<template>
    <div class="mainbody modulewrap realwrap">
        <div class="mymain">
            <div class="mywork">
                <Chome v-show="parpage.pname=='home'" :parpage.sync="parpage"> </Chome>
                <template v-if="parpage.pname!='home'">
                    <div class="mynav">
                        <dl>
                            <dd class="csite"><span>{{parpage.title}}</span></dd>
                            <dd class="cback"><a href="#" @click="goback">返回</a></dd>
                        </dl>
                    </div>

                    <component :is="pagecomponent" :parpage.sync="parpage" @goback="goback"></component>


                </template>
            </div>
            <div class="myside">
                <myScroll class="scroll">
                    <Cside :parpage.sync="parpage"></Cside>
                </myScroll>
            </div>
            <div class="topavatar" v-if="$store.state.islogin && $store.getters.issmall"><a href="#" @click="goprofile"><img :src="$common.getavatar( $store.state.avatar)" /></a></div>
        </div>
    </div>
</template>

<script>
    import Cside from '@/components/Cside';
    import Chome from '@/components/Chome';

    export default {
        name: 'home',
        data() {
            return {
                parpage: {
                    pname: 'home',
                    title: '',
                    id: 0
                }
            };
        },
        components: {
            Cside,
            Chome
        },
        computed: {
            pagecomponent: function () {
                return this.parpage.pname == 'home' ? null : () => import('@/components/C' + this.parpage.pname);
            }
        },
        methods: {
            goback: function () {
                if (this.parpage.pname == 'terms') {
                    this.parpage.id = 1;
                    this.parpage.pname = 'login';
                }
                else {
                    this.parpage.pname = 'home';
                }
            },
            goprofile: function () {
                this.parpage.pname = 'profile';
                this.parpage.title = '个人信息';
                this.parpage.id = 0;
                console.log(this.parpage);
            }
        }

    }
</script>
